import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { USER_TYPE_TEST_ID } from '../../render-type/user';
import { userTypeMessages } from '../../render-type/user/messages';
var userWrapperStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  font: 'font.body'
});
var avatarWrapperStyles = xcss({
  marginRight: 'space.100'
});
var emptyAvatarWrapperStyles = xcss({
  paddingBlock: 'space.050',
  paddingInline: 'space.100',
  opacity: 0,
  ':hover': {
    opacity: 1
  }
});
export var EmptyAvatar = function EmptyAvatar() {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: intl.formatMessage(userTypeMessages.userDefaultdisplayNameValue)
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: [userWrapperStyles, emptyAvatarWrapperStyles],
    testId: USER_TYPE_TEST_ID
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: avatarWrapperStyles
  }, /*#__PURE__*/React.createElement(Avatar, {
    appearance: "circle",
    size: 'small',
    testId: "".concat(USER_TYPE_TEST_ID, "--avatar")
  })), /*#__PURE__*/React.createElement(FormattedMessage, userTypeMessages.userDefaultdisplayNameValue)));
};